import { render, staticRenderFns } from "./CampaignScreenshots.vue?vue&type=template&id=3f4c985f&scoped=true&"
import script from "./CampaignScreenshots.vue?vue&type=script&lang=js&"
export * from "./CampaignScreenshots.vue?vue&type=script&lang=js&"
import style0 from "./CampaignScreenshots.vue?vue&type=style&index=0&id=3f4c985f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f4c985f",
  null
  
)

export default component.exports